import styled, { keyframes } from 'styled-components';
import StyleData from '../../utilities/StyleData';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const HeaderFixed = styled.div`
  left: 0;
  position: fixed;
  right: 0;
  z-index: 100;
  background-color: ${StyleData.color.base};
  max-width: 100vw;
  top: 0;
  width: 100%;
  font-family: ${StyleData.font.primary};
  line-height: 1.5;
  font-weight: 500;
  @media screen and (max-width: ${StyleData.breakpoints.max.lg}px) {
    padding-top: 4px;
  }
`;
export const HeaderContainer = styled.div`
  max-width: 1024px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
`;
export const HeaderContainerItems = styled.div`
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  max-width: 100%;
  margin: 0;
  padding: 0;
  .header-container-items {
    padding-bottom: 0.75rem;
    padding-top: 0.75rem;
    transition: all 0.5s;
    justify-content: space-between;
    display: flex;
    position: relative;
    @media screen and (max-width: ${StyleData.breakpoints.max.lg}px) {
      flex-direction: column;
      padding: 7px 0 0;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
    }
  }
`;
export const LogoContainer = styled.nav`
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 205px;
  height: 24px;
  @media screen and (max-width: ${StyleData.breakpoints.max.lg}px) {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
    margin: 0 15px;
    position: relative;
    width: auto;
    height: auto;
  }
`;
export const LogoMobileContainer = styled.div`
  display: none;
  @media screen and (max-width: ${StyleData.breakpoints.max.lg}px) {
    display: flex;
    margin-top: 7px;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
    position: relative;
    width: auto;
    height: auto;
  }
`;
export const LogoLinkMobile = styled.a`
  @media screen and (max-width: ${StyleData.breakpoints.max.lg}px) {
    :first-of-type {
      margin-right: 14px;
    }
    font-size: 18px;
    align-items: center;
    display: flex;
    vertical-align: middle;
  }
`;
export const Logo = styled.img`
  width: 205px;
  height: 24px;
  max-width: unset;
  align-self: center;
  @media screen and (max-width: ${StyleData.breakpoints.max.lg}px) {
    width: 154px;
    height: auto;
  }
`;
export const LogoLink = styled.a`
  flex-direction: column;
  position: relative;
  display: none;
  font-weight: 400;
  color: ${StyleData.color.text};
  text-decoration: none;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  @media screen and (max-width: ${StyleData.breakpoints.max.lg}px) {
    line-height: 1.38;
    margin-bottom: 3px;
    align-self: center;
    display: flex;
  }
`;
export const ElementContainer = styled.div`
  background-color: ${StyleData.color.base};
  display: flex;
  justify-content: flex-end;
  position: relative;
  overflow: visible;
  @media screen and (max-width: ${StyleData.breakpoints.max.lg}px) {
    background-color: ${StyleData.color.lightGrey};
    margin-top: 6px;
  }
`;
export const ElementContainerItems = styled.nav`
  position: relative;
  align-self: center;
  line-height: 1.2;
  @media screen and (max-width: ${StyleData.breakpoints.max.smd}px) {
    width: 100%;
  }
  @media screen and (min-width: ${StyleData.breakpoints.min.mmd}px) and (max-width: ${StyleData.breakpoints
      .max.lg}px) {
    margin: auto;
  }
`;
export const ElementContainerItemsNavigation = styled.div`
  max-width: 850px;
  margin-left: auto;
  line-height: 1.2;
  transition: transform 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  will-change: transform;
  white-space: nowrap;
  @media screen and (max-width: ${StyleData.breakpoints.max.smd}px) {
    background-color: ${StyleData.color.lightGrey} !important;
    padding: 6px 0;
    overflow-x: auto;
    position: relative;
    display: flex;
    justify-content: center;
    width: 100%;
  }
}
`;

export const UserAvatarImage = styled.img`
  aspect-ratio: 1 / 1;
  height: 2.25rem; /* 36px (h-9) */
  width: 2.25rem; /* 36px (pour 'aspect-square') */
  border-radius: 50%; /* rounded-full */
  object-fit: cover; /* object-cover */
`;

export const UserAvatarFallback = styled.div`
  aspect-ratio: 1 / 1;
  height: 2.25rem; /* 36px (min-h-[2.25rem]) */
  width: 2.25rem; /* 36px (aspect-square) */
  border-radius: 50%; /* rounded-full */
  /* Utilisation d'une couleur de votre thème pour 'bg-indigo' */
  background-color: ${StyleData.color.secondary};
  color: ${StyleData.color.white} !important; /* text-white */
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UserTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 292px;
  text-align: left;
  line-height: 1rem;
  color: ${StyleData.color.text};
`;

export const UserTextLine = styled.div<{ isBold?: boolean; isSmall?: boolean }>`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: ${(props) => (props.isBold ? 'bold' : '400')}; /* font-bold */
  font-size: ${(props) => (props.isSmall ? '0.75rem' : 'inherit')}; /* text-sm */
  color: ${(props) => (props.isSmall ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.8)')}; /* text-sm */
`;

export const HeaderButton = styled.a`
  background: transparent;
  text-decoration: none;
  border: 2px solid ${StyleData.color.secondary};
  border-radius: 30px;
  padding: 7px 12px;
  color: ${StyleData.color.secondary};
  margin-right: 0;
  margin-left: 10px;
  line-height: normal;
  font-size: 14px;
  :hover {
    background: ${StyleData.color.secondary};
    color: ${StyleData.color.base};
    cursor: pointer;
  }
  @media screen and (max-width: ${StyleData.breakpoints.max.lg}px) {
    display: none;
  }
`;

export const SpaceButton = styled.a`
  background: transparent;
  border-radius: 30px;
  padding: 3px 5px;
  color: ${StyleData.color.text} !important;
  margin-left: 17px;
  font-size: 14px;
  position: relative;
  cursor: pointer;
  border: 2px solid transparent;
  line-height: normal;
  text-decoration: none;
  box-shadow: 0 1px 3px 0px rgb(0 0 0 / 0.2);
  display: flex;
  align-items: center;
  gap: 8px; /* Espace entre les éléments */
  &.HelpButton {
    padding-right: 9px;
    padding-left: 7px;
    span {
      color: rgba(0, 0, 0, 0.8);
    }
    @media screen and (max-width: ${StyleData.breakpoints.max.lg}px) {
      display: none;
    }
  }
  &:hover {
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
  }
  .icon-chevron-down {
    padding-left: 0.25rem; /* pl-1 */
    vertical-align: middle; /* align-middle */
    /* La couleur est héritée (text) */
  }
`;

export const SpaceArea = styled.div`
  position: absolute;
  top: 100%; /* Positionné sous le bouton */
  right: 0; /* Aligné à droite du 'SpaceContainer' */
  z-index: 203;
  margin-top: 14px; /* Votre ancienne valeur 'top: 14px' sur .header-dropdown */
  width: max-content; /* S'adapte au contenu */

  /* Animation d'apparition */
  animation: ${fadeIn} 0.15s ease-out;

  /* Cache le dropdown pour les mobiles (votre ancien style) */
  @media screen and (max-width: ${StyleData.breakpoints.max.lg}px) {
    display: none;
  }
`;

export const SpaceContainer = styled.div`
  position: relative;
  display: flex;
  line-height: 1.2;
  @media screen and (max-width: ${StyleData.breakpoints.max.lg}px) {
    display: none;
  }
`;
export const HeaderDropdownContainer = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin: 0;

  /* Styles de l'exemple */
  display: flex;
  flex-direction: column;
  gap: 1rem; /* 16px, (traduit de gap-4) */
  border-radius: 0.75rem; /* 12px (traduit de rounded-xl) */
  background-color: ${StyleData.color.base}; /* (traduit de bg-white) */
  padding: 1.75rem 2rem; /* 28px 32px (traduit de px-8 py-7) */

  /* Votre ancienne ombre (plus forte que l'exemple, nous la gardons) */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.28) !important;
`;

export const HeaderLinkStyle = styled.a<{ tabletOnly?: boolean }>`
  ${(props) => {
    if (props.tabletOnly) {
      return `@media screen and (min-width: ${StyleData.breakpoints.min.xl}px) {
          display: none;
      }`;
    }
  }}
  display: flex;
  align-items: center;
  margin: 0 7px;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  vertical-align: middle;
  text-decoration: none;
  color: ${StyleData.color.text};
  padding: 3px 0;
  border-bottom: 2px solid transparent;
  :hover {
    color: ${StyleData.color.primary};
    svg {
      fill: ${StyleData.color.primary};
      g {
        fill: ${StyleData.color.primary};
      }
      path {
        color: ${StyleData.color.primary};
      }
    }
    span {
      text-decoration: underline;
    }
  }
  svg {
    margin-right: 5px;
  }
  @media screen and (max-width: ${StyleData.breakpoints.max.smd}px) {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    font-size: 10px;
    margin: 0;
    flex-grow: 1;
  }
  .desktop-text {
    @media screen and (max-width: ${StyleData.breakpoints.max.smd}px) {
      display: none;
    }
  }
  .mobile-tablet-text {
    @media screen and (min-width: ${StyleData.breakpoints.min.mmd}px) {
      display: none;
    }
  }
`;

export const HeaderLinkDropdownStyle = styled.a`
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  color: ${StyleData.color.text};
  font-weight: normal;
  position: relative;

  gap: 1rem; /* 16px */
  transition: color 0.2s;
  font-size: 1.25rem; /* 20px */
  svg,
  i {
    color: currentColor;
    width: 1.25rem;
    height: 1.25rem;
  }

  span {
    font-family: ${StyleData.font.secondary};
    font-size: 0.875rem;
    white-space: nowrap;
    margin-left: 0;
  }

  &:hover {
    color: ${StyleData.color.primary};
    span {
      color: ${StyleData.color.primary};
    }
  }
`;

export const NotificationBadge = styled.div<{ count: number }>`
  position: absolute;
  top: -4px;
  right: -4px;
  background-color: #ef3340;
  color: white;
  border-radius: 50%;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  z-index: 10;
  ${(props) => props.count === 0 && 'display: none;'}
`;

export const DropdownArrowContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-right: 2rem;
`;

export const DropdownArrow = styled.div`
  clip-path: polygon(0 100%, 50% 0, 100% 100%);
  height: 0.75rem; /* 12px */
  width: 1.25rem; /* 20px */
  /* Doit être de la même couleur que le 'HeaderDropdownContainer' */
  background-color: ${StyleData.color.base};
`;

export const DropdownDivider = styled.li`
  list-style-type: none;
  padding: 0;
  margin: 0.25rem 0; /* Petit espace vertical */
  border-bottom: 1px solid ${StyleData.color.text};
`;

export const HeaderLeftGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  @media screen and (max-width: ${StyleData.breakpoints.max.lg}px) {
    display: none;
  }
`;

export const AppIconButton = styled.a`
  text-decoration: none;
`;

export const AppIconWrapper = styled.div`
  background-color: ${StyleData.color.app};
  border-radius: 0.375rem; /* 6px */
  height: 2.25rem; /* 36px */
  width: 2.25rem; /* 36px */
  color: ${StyleData.color.base};
  place-items: center;
  display: grid;
  cursor: pointer;
  transition: all 0.3s ease;
  .icon-mat {
    height: 20px;
    display: block;
    transition: display 0.1s;
  }
  .icon-long-arrow-left {
    display: none;
    height: 20px;
    transition: display 0.1s;
  }

  ${AppIconButton}:hover & {
    .icon-mat {
      display: none;
    }
    .icon-long-arrow-left {
      display: block;
    }
  }
`;

export const HeaderTitle = styled.h1`
  color: ${StyleData.color.title};
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 400;
  margin: 0;
  padding: 0;
  font-family: ${StyleData.font.primary} !important;
  @media screen and (max-width: ${StyleData.breakpoints.max.smd}px) {
    display: none;
  }
`;

export const HelpIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1 / 1;
  height: 2.25rem; /* 36px */
  width: 1.825rem; /* 32px */
  border-radius: 50%; /* rounded-full */
  font-family: ${StyleData.font.primary};
  font-weight: 500;
  svg {
    height: 24px;
    width: 24px;
    fill: ${StyleData.color.text};
  }
`;

export const MenuButton = styled.a`
  /* Style de base (basé sur SpaceButton et HeaderMonEspaceButton) */
  background: transparent;
  border-radius: 30px;
  padding: 2px 18px;
  color: ${StyleData.color.text} !important;
  font-size: 14px;
  font-weight: 400;
  position: relative;
  cursor: pointer;
  border: 2px solid transparent;
  line-height: normal;
  text-decoration: none;
  box-shadow: 0 1px 3px 0px rgb(0 0 0 / 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  display: none;
  &:hover {
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
  }
  @media all and (max-width: 1880px) {
    display: flex;
  }
`;

export const MenuButtonIcon = styled.div`
  height: 20px;
  display: flex;
  cursor: pointer;
  align-items: end;
  justify-content: end;
`;

// Le texte "Menu"
export const MenuButtonText = styled.span`
  font-size: 0.8125rem; /* 13px (proche de 'text-smd') */
  line-height: 1rem; /* (leading-4) */
  font-weight: 400;
  cursor: pointer;
  user-select: none;
`;
